import * as React from 'react'
import { MdTable, MdPaginate } from '../widgets'

export class MdTableContainer extends React.Component<MdTableContainerProps, null> {
  constructor(props: any) {
    super(props)
  }

  public sortBy(col, id) {
    if (col.sortable) {
      let newCol = _.clone(col)
      newCol.sorted = (col.sorted === 'asc' ? 'desc' : 'asc')
      this.props.onSort(id, newCol)
    }
  }

 public render() {

    return (
      <div>
        <MdTable
          onSelectHeader={(col, id) => this.sortBy(col, id)}
          onSelectRow={(row) => this.props.onSelectRow(row)}
          header={this.props.datasetHeaders}
          dataset={this.props.dataset}
          selectedRow={this.props.selectedRow}
        />

        <MdPaginate
          onSelectPage={(page) => this.props.onChangePage(page)}
          totalPages={this.props.totalPages}
          pageStep={this.props.pageStep}
          currentPage={this.props.page}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./react/components/containers/MdTableContainer.tsx